import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotTopics from './components/HotTopics';
import LatestNews from './components/LatestNews';
import NewsletterSection from './components/NewsletterSection';

const faqQuestions = [
  {
    '@type': 'Question',
    name: '51吃瓜官网是什么？',
    acceptedAnswer: {
      '@type': 'Answer',
      text: '51吃瓜官网是国内领先的娱乐八卦资讯平台，提供全网最新吃瓜入口，涵盖明星八卦、独家爆料、综艺热点、影视资讯和网红动态等领域。每日更新，全部免费浏览。',
    },
  },
  {
    '@type': 'Question',
    name: '51吃瓜官网的内容免费吗？',
    acceptedAnswer: {
      '@type': 'Answer',
      text: '是的！51吃瓜官网所有八卦资讯全部免费在线浏览，不设置任何付费墙，让每一位吃瓜群众都能随时随地吃到最新鲜的瓜。',
    },
  },
  {
    '@type': 'Question',
    name: '如何订阅51吃瓜官网的最新资讯？',
    acceptedAnswer: {
      '@type': 'Answer',
      text: '在首页底部填写您的邮箱地址并点击"立即订阅"，我们会将每日最新八卦资讯推送到您的邮箱中。',
    },
  },
  {
    '@type': 'Question',
    name: '如何联系51吃瓜官网进行爆料？',
    acceptedAnswer: {
      '@type': 'Answer',
      text: '您可以通过"关于我们"页面的联系表单发送信息，也可以发送邮件至 hello@yjpslu.cn。无论是独家爆料还是商务合作，我们都欢迎您的来信。',
    },
  },
];

export default function Home() {
  useEffect(() => {
    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '51吃瓜官网 - 全网最新吃瓜入口',
        description: '51吃瓜官网提供全网最新吃瓜入口，实时更新今日最热八卦、独家爆料，直击明星绯闻与名人丑闻。每日吃瓜不停，全部免费在线吃瓜资源尽在掌握。',
        url: 'http://yjpslu.cn/',
        isPartOf: {
          '@type': 'WebSite',
          name: '51吃瓜官网',
          url: 'http://yjpslu.cn/',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '51吃瓜官网',
        url: 'http://yjpslu.cn/',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: 'http://yjpslu.cn/search?q={search_term_string}',
          },
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '51吃瓜官网',
        url: 'http://yjpslu.cn/',
        logo: {
          '@type': 'ImageObject',
          url: 'http://yjpslu.cn/logo.png',
        },
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'hello@yjpslu.cn',
          contactType: '客户服务',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqQuestions,
      },
    ];

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'home-schema';
    script.textContent = JSON.stringify(schemas);
    document.head.appendChild(script);

    const existing = document.querySelectorAll('script[id="home-schema"]');
    if (existing.length > 1) {
      existing[0].remove();
    }

    return () => {
      const el = document.querySelector('script[id="home-schema"]');
      if (el) document.head.removeChild(el);
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotTopics />
        <LatestNews />
        <FaqSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}

function FaqSection() {
  const faqs = [
    { q: '51吃瓜官网是什么？', a: '51吃瓜官网是国内领先的娱乐八卦资讯平台，提供全网最新吃瓜入口，涵盖明星八卦、独家爆料、综艺热点、影视资讯和网红动态等领域。每日更新，全部免费浏览。' },
    { q: '51吃瓜官网的内容免费吗？', a: '是的！51吃瓜官网所有八卦资讯全部免费在线浏览，不设置任何付费墙，让每一位吃瓜群众都能随时随地吃到最新鲜的瓜。' },
    { q: '如何订阅51吃瓜官网的最新资讯？', a: '在首页底部填写您的邮箱地址并点击"立即订阅"，我们会将每日最新八卦资讯推送到您的邮箱中。' },
    { q: '如何联系51吃瓜官网进行爆料？', a: '您可以通过"关于我们"页面的联系表单发送信息，也可以发送邮件至 hello@yjpslu.cn。无论是独家爆料还是商务合作，我们都欢迎您的来信。' },
  ];

  return (
    <section className="py-14 md:py-18 bg-background-50">
      <div className="w-full max-w-[860px] mx-auto px-4 md:px-6">
        <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-2 text-center">
          常见问题
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-8">
          关于51吃瓜官网，你可能想知道这些
        </p>
        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <summary className="flex items-center justify-between gap-3 px-5 py-4 cursor-pointer list-none select-none">
                <span className="font-medium text-foreground-900 text-sm">
                  {faq.q}
                </span>
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform text-lg flex-shrink-0" />
              </summary>
              <div className="px-5 pb-4 text-foreground-600 text-sm leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}